import { render, staticRenderFns } from "./unprofitable-products-statistics.vue?vue&type=template&id=4cc37d07"
import script from "./unprofitable-products-statistics.vue?vue&type=script&lang=js"
export * from "./unprofitable-products-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports